// extracted by mini-css-extract-plugin
module.exports = {"component":"modal_component__3xGLM","isOpened":"modal_isOpened__OVNRK","content":"modal_content__1tQ-X","close":"modal_close__1Iez6"};